import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setNumberOfPiles,
  setNumberOfPileheads,
  setNumberOfTestsForTypeDINByNumberOfPiles,
  selectNumberOfPiles,
  selectPileDiameter,
} from "../../../../store/slices/lvTextSlice";
import {
  selectBemessungssituation,
  selectBerechneInnere,
} from "../../../../store/slices/innereSlice";
import { selectTragglied } from "../../../../store/slices/traggliedSlice";
import { useGetTraggliedDatenQuery } from "../../../../services/API/titanApi";
import { selectBelastungsartUndRichtung } from "../../../../store/slices/belastungsartUndRichtungSlice";
import { selectLongestPfahlValuePlusExtension } from "../../../../store/slices/aeussereSlice";
import { selectPfahlneigungZurVertikalen } from "../../../../store/slices/aeussereSlice";

import Headline from "../../../../components/UI/Headline";
import NumberOfPiles from "./NumberOfPiles";
import OperationDuration from "./OperationDuration";
import PermissibleLoadCapacity from "./PermissibleLoadCapacity";
import CarryingElement from "./CarryingElement";
import LoadDirection from "./LoadDirection";
import TotalPileLength from "./TotalPileLength";
import PileInclinationVerticle from "./PileInclinationVertical";
import PileDiameter from "./PileDiameter";

export default function PositionMicropiles() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");

  const numberOfPiles = useSelector(selectNumberOfPiles);
  const dispatchSetNumberOfPilesAndNumberOfPileheadsPlusSetNumberOfTestsForTypeDIN = (value) => {
    dispatch(setNumberOfPiles(value));
    dispatch(setNumberOfPileheads(value));
    dispatch(setNumberOfTestsForTypeDINByNumberOfPiles(value));
  };

  const operationDuration = useSelector(selectBemessungssituation);

  const tragglied = useSelector(selectTragglied);
  const carryingElement = tragglied.title;

  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  const innereData = useSelector(selectBerechneInnere(traggliedDaten));
  const permissibleLoadCapacity = innereData?.Rcd;

  const loadDirection = useSelector(selectBelastungsartUndRichtung);

  const totalPileLength = useSelector(selectLongestPfahlValuePlusExtension);

  const pileInclinationVerticle = useSelector(selectPfahlneigungZurVertikalen);

  const pileDiameter = useSelector(selectPileDiameter());

  return (
    <div className="mt-5">
      <Headline text={t("lvText.positionMicropiles.headline")} />
      <NumberOfPiles
        value={numberOfPiles}
        set={dispatchSetNumberOfPilesAndNumberOfPileheadsPlusSetNumberOfTestsForTypeDIN}
      />
      <OperationDuration value={operationDuration} />
      <PermissibleLoadCapacity value={permissibleLoadCapacity} />
      <CarryingElement value={carryingElement} />
      <LoadDirection value={loadDirection} />
      <TotalPileLength value={totalPileLength} />
      <PileInclinationVerticle value={pileInclinationVerticle} />
      <PileDiameter value={pileDiameter} />
    </div>
  );
}
